import {
  IDataArray,
  DataArray,
  Company,
  Minesite,
  Permission,
  SectionPermission,
  UserCompany,
} from "./../../shared/index";

export class FMIProduct implements IDataArray {
  public Id = 0;
  public FileMetadataID = 0;
  public ProductSourceID: number = null;
  public ProductName: string;
  public ProductDescription: string;
  public PubType: string;
  public Language: string;
  public Template: string;
  public Model: string;
  public Division: string;
  public CDPrice: number = null;
  public BookPrice: number = null;
  public FlashDrivePrice: number = null;
  public ProManualTitle: string;
  public PublishToProManual: boolean;
  public ProManualPublicationNumber: string;
  public ExpirationDate: Date;
  public AllowPrinting: boolean;
  public Version: string;
  public CreatedOn: Date;
  public CreatedBy: string;
  public ModifiedOn: Date;
  public ModifiedBy: string;
  public IsPulledFromMidlandFMI = false;
  public IsNonConformingDocument = false;
  public TitaniaUrl: string;

  public GetById(): number {
    return this.Id;
  }
}
